import { motion } from "framer-motion";

export default function SectionHeading({ eyebrow, title, sub }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="max-w-2xl"
    >
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-emerald-400 mb-4 flex items-center gap-3">
        <span className="h-px w-8 bg-emerald-400/60" />
        {eyebrow}
      </p>
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-white leading-[0.95]">
        {title}
      </h2>
      {sub && <p className="mt-4 text-slate-400 leading-relaxed">{sub}</p>}
    </motion.div>
  );
}